import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import { clsx } from "clsx";
/* empty css                 */
const ButtonGroup = forwardRef((props, ref) => {
  const $ = c(6);
  let t0;
  if ($[0] !== props.className) {
    t0 = clsx("graphiql-button-group", props.className);
    $[0] = props.className;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props || $[3] !== ref || $[4] !== t0) {
    t1 = /* @__PURE__ */ jsx("div", { ...props, ref, className: t0 });
    $[2] = props;
    $[3] = ref;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
});
ButtonGroup.displayName = "ButtonGroup";
export {
  ButtonGroup
};
//# sourceMappingURL=button-group.js.map
